export default "__VITE_ASSET__B4hP4LFx__"